import Util from '../util/Plaintext.Util';

class TableOfContents {
  constructor(el) {
    this.tocEl = el;
    this.build();
  }
  
  build() {
    const topLevelItems = this.getTopLevelItems();
    const tocHtml = this.getLevelHtml(topLevelItems);

    this.tocEl.innerHTML = tocHtml;
  }
  
  getTopLevelItems() {
    const nodes = document.querySelectorAll('h1[id],h2[id],h3[id],h4[id],h5[id],h6[id]');
    const state = { nodes, index: 0 };
    return this.getLevel(state).items;
  }
  
  getLevel(state) {
    let index = state.index;
    const nodes = state.nodes;
    const nodeCount = nodes.length;
    const items = [];
    
    if (index >= nodeCount) { return { nodes, items, index }; }
    
    const curLevel = nodes[index].nodeName.substring(1);
    const curItem = {};
    
    for (; index < nodeCount; index++) {
      const node = nodes[index];
      const nodeLevel = node.nodeName.substring(1);

      // Same level?  Add to items and continue
      if (nodeLevel === curLevel) {
        items.push({ node, children: null });
      }
      // Higher level?  We're done with this level.
      else if (nodeLevel < curLevel) {
        return { nodes, items, index };
        break;
      }
      // Lower level?  Add the children to the previous item and continue
      else {
        const lastItem = items[items.length - 1];
        const childLevelState = { nodes, index };
        const childResultState = this.getLevel(childLevelState);
        // -1 since we'll be adding one at the end of the loop
        index = childResultState.index - 1;
        lastItem.children = childResultState.items;
      }
    }

    return { nodes, items, index };
  }
  
  getLevelHtml(levelItems, level = 0) {
    const cssClass = `tocList tocList--level${ level + 1}`;
    return `<ol class='${ cssClass }'>${ levelItems.map(item => this.htmlFromItem(item, level)).join('') }</ol>`;
  }
  
  htmlFromItem(item, level) {
    const node = item.node;
    const id = node.id;
    const title = node.innerText;
    const link = document.createElement('a');
    
    link.href = `#${ id }`;
    link.innerText = node.innerText;
    
    const linkHtml = link.outerHTML;
    const childrenHtml = item.children ? this.getLevelHtml(item.children, level + 1) : '';
    
    return `<li class='tocItem'>${ linkHtml }${ childrenHtml }</li>`;
  }
}

TableOfContents.enable = function(targetSrc) {
  Util.elementsFrom(targetSrc).forEach(el => new TableOfContents(el))
}


export default TableOfContents;